import DtoUserStatistic from './DtoUserStatistic'

export default class DtoUserCmsStatistic extends DtoUserStatistic {
    constructor(obj) {
        super(obj)
    }
}